import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d7412f18"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=d7412f18&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_wb3t4kok4nbmrmr53k32ebcn2u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports